<template>
  <div class="input-textarea">
    <label :for="name">
      <textarea
        :id="name"
        v-model="inputVal"
        :class="isDirty"
        :style="`resize: ${resize}; height: ${height};`"
        placeholder=" "
        required
      />
      <span class="label" v-html="label" />
      <span class="border" />
    </label>
  </div>
</template>

<script>
export default {
  name: "InputTextarea",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: "0"
    },
    resize: {
      type: String,
      default: "none"
    },
    value: String
  },
  computed: {
    isDirty: function() {
      return this.value.length ? "is-dirty" : "";
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-textarea {
  display: inline-block;
  padding: 12px 5px 0;
  label {
    display: grid;
    position: relative;
    width: 100%;
    height: 92px;
  }

  textarea {
    display: block;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    margin-top: 12px;
    font-size: 16px;
    font-weight: 300;
    font-family: inherit;
    color: $color-primary-1;
    background: none;
    border: 0;
    border-bottom: 1px solid $background-color-clear-1;
    border-radius: 0;
    box-shadow: none;
    outline: 0;
    &:hover {
      background: rgba(255, 255, 255, 0.05); // TODO
    }
    &:not(:placeholder-shown) {
      + span {
        transform: translateY(-16px) scale(0.75);
      }
    }
    &:focus {
      background: none;
      outline: none;
      + span {
        color: $color-secondary-1;
        transform: translateY(-16px) scale(0.75);
        + .border {
          transform: scaleX(1);
        }
      }
    }
    &.is-dirty {
      + span {
        transform: translateY(-16px) scale(0.75);
      }
      &:focus {
        + span {
          color: $color-secondary-1;
          + .border {
            background: $background-color-secondary-1;
          }
        }
      }
      &:invalid {
        + span {
          color: $color-error-1;
          + .border {
            transform: scaleX(1);
            background: $color-error-1;
          }
        }
      }
    }
    :not(:empty) {
      background: none;
      outline: none;
      + span {
        color: $color-secondary-1;
        transform: translateY(-16px) scale(0.75);
        + .border {
          transform: scaleX(1);
        }
      }
    }
  }

  .label {
    position: absolute;
    top: 16px; // input margin-top 12px + input height create padding 4px
    left: 0;
    font-size: 16px;
    color: $color-primary-1;
    transform-origin: 0 0;
    transition: all $input-transition-duration $input-transition-timing-function;
  }
  .border {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background: $background-color-secondary-1;
    transform: scaleX(0);
    transform-origin: 0 0;
    transition: all $input-transition-duration $input-transition-timing-function;
  }
}

/* IE Fix */

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .input-textarea {
    text-align: left;
    textarea {
      &:focus {
        border-bottom: 1px solid $background-color-secondary-1;
      }
    }
    .border {
      display: none;
    }
  }
}

/* Auto-fill fix */
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 50px $background-color-primary-1 inset !important;
    -webkit-text-fill-color: $color-primary-1 !important;
    background-color: transparent !important;
}
</style>
